import { connect } from 'react-redux'

import IssueHistoryCard from '../../components/issue-histories/issue-history-card'

function mapStateToProps(state, ownProps) {
  const updatedBy = state.users[ownProps.history.updatedBy]
  const issueDescription = state.issueDescriptions[ownProps.history.issueDescription]

  return {
    issueDescription,
    updatedBy
  }
}

export default connect(mapStateToProps)(IssueHistoryCard)



// WEBPACK FOOTER //
// ./src/containers/issue-histories/issue-history-card-container.js